export class ReportFilterModel {
}

export class ReportFilterModelData {
    key: string;
    value: string;
}
